// Pack du site vitrine (layout www, #16078) : les styles et le JS des seules pages du vitrine,
// au lieu du pack `application` des espaces connectés.
//
// Styles : feuille de base, CSS importé par les contrôleurs, SCSS des composants, puis les
// utilitaires Tailwind en dernier pour qu'ils gagnent la cascade.

require("stylesheets/www.scss");
require("stylesheets/generateur.scss");

// CSS importé par les contrôleurs Stimulus du vitrine
require("stylesheets/accordion.scss");
require("mapbox-gl/dist/mapbox-gl.css");
require("stylesheets/app/catalog/search.scss");
require("stylesheets/password_checker.scss");
require("quill/dist/quill.snow.css");

// SCSS des composants rendus par le vitrine. Toute la famille form/ : le form builder
// peut rendre n'importe lequel de ses champs.
require("components/accordion/component");
require("components/alert/component");
require("components/avatar/component");
require("components/badge/component");
require("components/burger/component");
require("components/button/component");
require("components/dropdown/component");
require("components/form/component");
const formComponents = require.context("components/form", true, /[_/]component\.js$/);
formComponents.keys().forEach(formComponents);
require("components/gallery/component");
require("components/map/component");
require("components/map_autocomplete/component");
require("components/modal/component");
require("components/navbar/component");
require("components/oqoro_stripe/payment_intent/component");
require("components/scroller/component");
require("components/slide_over/component");
require("components/slider/component");
require("components/tab/component");

require("stylesheets/tailwind-utilities-www.scss");

// JS, en require et non en import : un import serait remonté en tête du fichier, et le CSS que
// chargent les contrôleurs passerait avant la feuille de base dans le bundle.
require("./turbo_setup");
require("./ahoy_setup");
// Formulaire de filtres de /recherche (GET en turbo-stream)
require("libs/form");
require("controllers/www");
